export default __webpack_public_path__ + "static/media/hht2_ep02_timeline_04.e6999cb7.png";